import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

import { useSpline } from "../../../context/SplineContext";

import sLetter from "../../../assets/s-letter.svg";
import mLetter from "../../../assets/m-letter.svg";
import pLetter from "../../../assets/p-letter.svg";
import lLetter from "../../../assets/l-letter.svg";
import sGreenLetter from "../../../assets/s-green-letter.svg";
import oLetter from "../../../assets/o-letter.svg";
import lPinkLetter from "../../../assets/l-pink-letter.svg";
import dotLetter from "../../../assets/dot-letter.svg";

gsap.registerPlugin(ScrollTrigger);

export default function OurSmpl() {
  const { splineObjectRef, isSplineReady } = useSpline();

  const mobile = window.matchMedia("(max-width: 768px)").matches;

  useEffect(() => {
    if (!isSplineReady || !splineObjectRef.current) return;

    const obj = splineObjectRef.current;
    console.log(obj.scale);
    const triggerPart = document.querySelector("#our_smpl");

    const aboutTl = gsap.timeline({
      scrollTrigger: {
        trigger: triggerPart,
        start: "top top",
        end: "bottom bottom",
        // markers: true,
        scrub: 0.5,
      },
    });

    if (mobile) {
      aboutTl
        .to(".spline-parent", {
          duration: 1,
          opacity: 0.01,
        })
        .to(
          ".our-smpl-assets__img--1",
          {
            x: "-40rem",
            y: "-31rem",
            rotate: "29deg",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--2",
          {
            x: "-16rem",
            y: "-46rem",
            rotate: "14deg",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--3",
          {
            x: "14rem",
            y: "-39rem",
            rotate: "-35deg",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--4",
          {
            x: "39rem",
            y: "-36rem",
            rotate: "11deg",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--5",
          {
            x: "-38rem",
            y: "39rem",
            rotate: "-26deg",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--6",
          {
            x: "-11.1rem",
            y: "44rem",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--7",
          {
            x: "21rem",
            y: "43rem",
            rotate: "-28deg",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--8",
          {
            x: "39.6rem",
            y: "33rem",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__text p",
          {
            y: "0px",
            opacity: 1,
            duration: 1,
          },
          "-=.5"
        );
    } else {
      aboutTl
        .to(".spline-parent", {
          duration: 1,
          opacity: 0.01,
        })
        .to(
          ".our-smpl-assets__img--1",
          {
            x: "-31rem",
            y: "-7rem",
            rotate: "29deg",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--2",
          {
            x: "-14rem",
            y: "-17rem",
            rotate: "14deg",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--3",
          {
            x: "9rem",
            y: "-16rem",
            rotate: "-35deg",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--4",
          {
            x: "29rem",
            y: "-12rem",
            rotate: "11deg",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--5",
          {
            x: "-23rem",
            y: "15rem",
            rotate: "-22deg",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--6",
          {
            x: "-2rem",
            y: "15rem",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--7",
          {
            x: "21rem",
            y: "14rem",
            rotate: "-30deg",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__img--8",
          {
            x: "29rem",
            y: "6rem",
            duration: 1,
          },
          "-=1"
        )
        .to(
          ".our-smpl-assets__text p",
          {
            y: "0px",
            opacity: 1,
            duration: 1,
          },
          "-=.5"
        );
    }
  }, [isSplineReady]);
  return (
    <>
      <section id="our_smpl">
        <div className="our-smpl-wrapper">
          <div className="our-smpl-assets">
            <div className="our-smpl-assets__img">
              <div className="our-smpl-assets__img--all our-smpl-assets__img--1">
                <img src={sLetter} alt="s letter" />
              </div>
              <div className="our-smpl-assets__img--all our-smpl-assets__img--2">
                <img src={mLetter} alt="m letter" />
              </div>
              <div className="our-smpl-assets__img--all our-smpl-assets__img--3">
                <img src={pLetter} alt="p letter" />
              </div>
              <div className="our-smpl-assets__img--all our-smpl-assets__img--4">
                <img src={lLetter} alt="l letter" />
              </div>
              <div className="our-smpl-assets__img--all our-smpl-assets__img--5">
                <img src={sGreenLetter} alt="s letter" />
              </div>
              <div className="our-smpl-assets__img--all our-smpl-assets__img--6">
                <img src={oLetter} alt="o letter" />
              </div>
              <div className="our-smpl-assets__img--all our-smpl-assets__img--7">
                <img src={lPinkLetter} alt="l letter" />
              </div>
              <div className="our-smpl-assets__img--all our-smpl-assets__img--8">
                <img src={dotLetter} alt="dot letter" />
              </div>
            </div>
            <div className="our-smpl-assets__text">
              <p>
                We’re a lean, no-nonsense marketing and brand consultancy that
                partners with forward-thinking clients to kick mediocrity to the
                curb. Based in the UAE, we move fast, think sharper, and keep
                your brand agile – from positioning and identity to full-scale
                activation.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
